document.addEventListener('DOMContentLoaded', function(){

    const slider=document.querySelector('.mm-shop-look-slider');

    if(!slider) return;

    const mainSwiper = new Swiper('.mm-shop-look-slider', {
        slidesPerView: 1,
        speed: 600,
        autoHeight: true,
        navigation: {
            nextEl: '.mm-shop-look-next',
            prevEl: '.mm-shop-look-prev'
        }
    });


    if (window.innerWidth < 992) {

        document.querySelectorAll('.mm-shop-look-product-slider').forEach(function(slider) {

            const productSwiper = new Swiper(slider,{
                slidesPerView:'auto',
                spaceBetween:15,
                freeMode:true,
                nested:true,
                watchOverflow:true
            });

            new Swiper(slider,{
                slidesPerView: 'auto',
                spaceBetween:15,
                freeMode:true,
                watchOverflow:true
            });

        });

    }

});
